import BedsTableEmptyMessage from "./BedsTableEmptyMessage";

export default BedsTableEmptyMessage;